import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Separator } from "@/components/ui/separator";
const accordionData = [{
  id: "awards",
  title: "Experience & Credentials",
  content: "Shaik Azrin bin Shaik Daud started off his legal career at Shearn Delamore & Co where he learnt the ropes of providing top legal counsel. After 8 years, Shaik Azrin branched off to establish Shaik Azrin & Co. Shaik Azrin now handles diverse civil litigation matters including corporate windingup petitions, defamation suits, debt recovery actions, and injunction applications. Aswell as successfully represented clients in complex dismissal cases involving constructive dismissal, redundancy, probationary and performance issues, and misconduct allegations."
}];
export default function MeetTheChocolatier() {
  return <section data-section-id="250411" id="the-partners" className="bg-background text-foreground py-24 md:py-32 relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          
          {}
          <div className="lg:col-span-5 relative">
            {}
            <Separator orientation="vertical" className="absolute -left-4 md:-left-8 top-12 h-[80%] w-[2px] bg-primary hidden md:block" />
            
            <div className="relative aspect-[4/5] w-full overflow-hidden shadow-2xl rounded-sm">
              <img src="https://shaikazrinco.com/wp-content/uploads/2026/05/7e5aa7b2-d5bf-427d-b77f-12b84f71e1b3.jpg" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662932/img/shaik_azrin_portrait.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662932/img/shaik_azrin_portrait.png-wvc-sizes" alt="Portrait of Mr. Shaik Azrin" className="object-cover w-full h-full transition-all duration-700 ease-in-out hover:scale-105" loading="lazy" />
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-transparent to-transparent"></div>
            </div>
          </div>

          {}
          <div className="lg:col-span-7 relative">
            {}
            <Separator orientation="vertical" className="absolute -left-6 top-2 h-24 w-[2px] bg-primary hidden lg:block" />
            
            <div className="pl-0 lg:pl-6">
              <h2 className="font-default font-bold tracking-tight mb-2 uppercase text-foreground !text-5xl">
                The Founder
              </h2>
              <h3 className="text-2xl md:text-3xl text-primary font-serif italic mb-8">
                Shaik Azrin bin Shaik Daud
              </h3>
              
              <p className="text-muted-foreground text-lg mb-12 leading-relaxed max-w-2xl font-default !text-justify">An experienced advocate and solicitor with nearly three decades of experience in the Malaysian legal landscape. Specializing in Employment Law and Civil Litigation, Shaik Azrin is an expert in said practices and has a reputation for making every case that falls to his feet honored and heard. Bound by his integrity he continues to build his legacy by navigating the complexities in the legal world.&nbsp;</p>

              <Accordion type="single" collapsible className="w-full max-w-2xl">
                {accordionData.map((item, index) => <AccordionItem key={item.id} value={item.id} data-index={index} className="border-border/30">
                    <AccordionTrigger className="text-lg md:text-xl font-default font-semibold hover:text-primary transition-colors py-6 text-foreground">
                      {item.title}
                    </AccordionTrigger>
                    <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-6 font-default">
                      {item.content}
                    </AccordionContent>
                  </AccordionItem>)}
              </Accordion>
            </div>
          </div>
          
        </div>
      </div>
    </section>;
}